import { render, staticRenderFns } from "./BranchProviderEditor.vue?vue&type=template&id=ecdf877a&scoped=true&"
import script from "./BranchProviderEditor.vue?vue&type=script&lang=js&"
export * from "./BranchProviderEditor.vue?vue&type=script&lang=js&"
import style0 from "./BranchProviderEditor.vue?vue&type=style&index=0&id=ecdf877a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdf877a",
  null
  
)

export default component.exports